import { render, staticRenderFns } from "./ButtonPagination.vue?vue&type=template&id=22e9ddcb&scoped=true&lang=pug"
import script from "./ButtonPagination.vue?vue&type=script&lang=ts"
export * from "./ButtonPagination.vue?vue&type=script&lang=ts"
import style0 from "./ButtonPagination.vue?vue&type=style&index=0&id=22e9ddcb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e9ddcb",
  null
  
)

export default component.exports